export default {
  event: {
    events: 'イベント',
    societe: '会社',
    contact: 'イベント担当者',
    list_of_events: 'イベント一覧',
    new_event: '新規イベント',
    participer: '表示',
    name_of_the_event: 'イベント名',
    date: '日付',
    country: '国',
    creator: '作成者',
    status: 'ステータス',
    simple_extraction: '簡易抽出',
    full_extraction: '完全抽出',
    upload_csv: 'CSVをアップロード',
    add_exhibitors: '出展者を追加',
    find_an_exhibitors: '出展者を検索',
    list_of_exhibitors: '出展者一覧',
    export_exhibitors: '出展者をエクスポート',
    event_informations: 'イベント情報',
    start_event: 'イベント開始日',
    year_of_the_event: 'イベント開催年',
    select_year: '年を選択',
    end_event: 'イベント終了日',
    city_of_event: 'イベント開催都市',
    country_of_event: 'イベント開催国',
    registration_closing_date: '登録締切日',
    showroom_on_event: 'このイベントのショールーム',
    hub_on_event: 'このイベントのハブ',
    showroom_informations: 'ショールーム情報',
    hub_informations: 'ハブ情報',
    animation_title: 'アニメーションのタイトル',
    animation_description: 'アニメーションの説明',
    thematic_title: 'テーマのタイトル',
    thematic_description: 'テーマの説明',
    event_color: '色',
    catalog_products_limit: 'eカタログの最大製品数',
    thematic_enabled: 'テーマを有効にする',
    thematic_selection_count: '選択数',
    number_of_products: '製品数',
    select_number_of_products: '製品数を選択',
    sample_informations: 'サンプル情報',
    numbers_of_sample_send: '送付するサンプル数',
    address_to_send_semple: 'サンプルの送付先住所',
    limit_date_to_receive_sample: 'サンプル受領期限',
    registration: '登録',
    event_information: 'イベント情報',
    export_profile: '輸出プロフィール',
    questionnaire: 'ターゲット市場と輸出実績',
    questionnaire_title: 'アンケートのタイトル',
    trade_name: '商号',
    trade_name_subtitle:
      'スタンド、フロアプラン、カタログなど、当社の各種広報媒体に掲載したい表記でご記入ください。',
    trade_name_local: '商号（現地語）',
    trade_name_local_subtitle: '非ラテン文字：中国語、日本語、韓国語など',
    trade_name_local_placeholder:
      '現地語の商号（非ラテン文字：中国語、日本語、韓国語など）',
    contact_for_this_event: 'このイベントの担当者',
    informations_visibles_sur_le_e_catalogue: 'eカタログに表示される情報',
    information_de_la_societe: '会社情報',
    sur_name: '姓',
    last_name: '姓',
    mobile_phone: '携帯電話',
    email: 'メールアドレス',
    contact_position: '担当者の役職',
    your_products: '選択した製品',
    your_products_catalog: 'eカタログ用に選択した製品',
    possibility_of_presenting_up_to_10_references:
      '最大{{count}}点まで紹介できます',
    select_product: '製品を選択',
    add_a_new_product: '新しい製品を作成',
    save: '保存',
    save_and_transmit: '保存して送信',
    possibility_to_reconnect_and_sequence_the_entry_of_information:
      '*再ログインして、情報を複数回に分けて入力できます。',
    your_entry_is_finalized_the_elements_can_no_longer_be_modified:
      '**入力が確定しました。内容は変更できなくなります。',
    date_of_event: 'イベント日',
    add_product_from_catalog: 'カタログから製品を追加',
    invite: '招待',
    website_title: 'ウェブサイトのタイトル',
    website_informations: 'ウェブサイト情報',
    header_logo_left: 'ヘッダーロゴ（左）',
    header_logo_left_two: 'ロゴ n°2 左上',
    header_logo_right: 'ヘッダーロゴ（右）',
    subtitle_of_the_event: 'イベントのサブタイトル',
    logo: 'ロゴ',
    download_exhibitors_hd_logos: '出展者HDロゴをダウンロード',
    download_exhibitors_hd_logos_started: 'ZIPファイルを生成しています…',
    e_catalogue_url: 'eカタログURL',
    inviter_par_email: 'メールで招待',
    send_email: 'メールを送信',
    copy_the_link: 'リンクをコピー',
    copy_the_link_success: '招待コードをコピーしました',
    invite_with_email: 'メールで招待*',
    import_exhibitor_database: '出展者データベースをインポート',
    active: '有効',
    icon: 'カタログから選択した製品を追加',
    dossier: 'ファイル',
    edit: '編集',
    required: 'この項目は必須です',
    number_exhibitors: 'このイベントに登録された出展者数',
    number_admins: 'このイベントに登録された管理者数',
    add_exhibitor_to_the_event: 'イベントに出展者を追加',
    company: '会社名',
    type_of_product: '製品タイプ',
    color_of_wine: 'ワインの色',
    grape_varietal: 'ブドウ品種',
    type_of_growing: '栽培方法',
    add_exhibitor: '出展者を追加',
    search: '検索',
    add_exhibitor_to_the_event_selection: '選択した出展者を追加',
    exhibitror_successfilly_updated: '出展者情報を更新しました',
    mandatory_information_missing:
      '必須情報が不足しています。「会社」タブで会社プロフィールを入力してください',
    add_the_least_one_product:
      'ファイルを送信するには、少なくとも1点の製品を追加してください',
    loading: '読み込み中',
    prepare_csv: 'CSVを準備',
    thematic: 'テーマ',
    thematic_choice: 'テーマ選択 No.',
    download_pdf: 'PDFをダウンロード',
    ok: 'OK',
    confirmation: '確認',
    commercial_name: '商号',
    animation: 'アニメーション',
    no_product_available: '利用可能な製品がありません',
    showroom_logo: 'ショールームのロゴ',
    no_thematic_found: 'テーマが見つかりません',
    limit: '上限',
    preview: 'プレビュー',
    exhibitor_list: '出展者リスト',
    product_list: '製品リスト',
    offer_page: 'オファーページ',
    color: '色1',
    second_color: '色2',
    facturation_code: '請求コード',
    category: 'カテゴリ',
    select_category: 'カテゴリを選択',
    all_categories: 'すべてのカテゴリ',
    offers: 'オファー',
    offer_name: 'オファー名',
    price: '価格',
    price_ht: '税抜価格',
    quantity: '数量',
    total_ht: '税抜合計',
    connector_admin: 'コネクター管理',
    add: '追加',
    add_admin: '管理者を追加',
    invite_to_admin: '管理者として招待',
    add_admin_to_the_event: 'イベントに管理者を追加',
    add_admin_to_the_event_selection: '選択した管理者を追加',
    already_added: '追加済み',
    remove_admin: '削除',
    no_admin_found: '管理者が見つかりません',
    admin_added_to_event: 'イベントに管理者を追加しました',
    admin_removed_from_event: 'イベントから管理者を削除しました',
  },
};
